'user client';

import styled from 'styled-components';

import Bullet from './Bullet';
import { parseSanitizedHTML } from '@/utils/helpers';

type LineProps = {
  $level: number;
  $icon?: string;
};

const Line = styled.div<LineProps>`
  color: ${props => (props.$icon === 'caution' ? 'red' : 'inherit')};
  font-size: 15px;
  line-height: 24px;
  margin-left: ${props => (props.$level ? props.$level * 30 : 0)}px;
  position: relative;
  padding-left: 37px;
  width: auto;
  word-break: break-word;

  &:not(:first-child) {
    margin-top: 1rem;
  }

  p {
    margin-top: 0;
  }
`;

type Meta = {
  level?: number;
  icon?: 'caution' | 'note' | 'reminder';
  color?: string;
};

type LineData = {
  id: string;
  title: string;
  order: number;
  meta?: Meta;
};

type LinesProps = {
  data?: LineData[];
  isLoading?: boolean;
};

export default function Lines({ data, isLoading }: LinesProps) {
  // Helper function to get random width between 50% and 100%
  const getRandomWidth = () => {
    return `${Math.floor(Math.random() * 51) + 50}%`;
  };

  return isLoading ? (
    <>
      <div
        className="pulse"
        style={{
          height: '18px',
          marginBottom: '16px',
          width: getRandomWidth(),
        }}
      />
      <div
        className="pulse"
        style={{
          height: '18px',
          marginBottom: '16px',
          marginTop: '16px',
          width: getRandomWidth(),
        }}
      />
      <div
        className="pulse"
        style={{
          height: '18px',
          marginBottom: '16px',
          marginTop: '16px',
          width: getRandomWidth(),
        }}
      />
      <div
        className="pulse"
        style={{
          height: '18px',
          marginBottom: '16px',
          marginTop: '16px',
          width: getRandomWidth(),
        }}
      />
      <div
        className="pulse"
        style={{
          height: '18px',
          marginBottom: '16px',
          marginTop: '16px',
          width: getRandomWidth(),
        }}
      />
      <div
        className="pulse"
        style={{
          height: '18px',
          marginTop: '16px',
          width: getRandomWidth(),
        }}
      />
    </>
  ) : (
    data
      ?.sort((a, b) => a.order - b.order)
      .map(({ meta = {}, id, title }) => {
        const { level = 0, icon, color } = (meta as Meta) || {};

        return (
          <Line key={id} $level={level} $icon={icon}>
            <Bullet icon={icon} color={color} />
            {parseSanitizedHTML(title, true)}
          </Line>
        );
      })
  );
}
